// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function Presentation(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Presentation" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 3H3V16H10L3 21H5.5L11 17.5V21H13V17.5L18 21H20.5L14 16H21V3ZM5 7H8.5V10.5H5V7ZM11 5.5H15V7H11V5.5ZM18.5 8.5H11V10H18.5V8.5ZM16 11.5V13H11V11.5H16Z", fill: "currentColor" }))));
});
//# sourceMappingURL=Presentation.js.map